<template>
  <div>
    <el-table :data="tzLoadMaterialRecordNg" stripe border height="500" style="width: 100%;height:100%">
      <el-table-column prop="ngReason" label="不良原因" min-width="50" />
      <el-table-column prop="completedCount" label="数量" min-width="50" />
    </el-table>
  </div>
</template>

<script>
export default {
  name: "BusTzFtLoadMaterialRecordNg",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return{
      tzLoadMaterialRecordNg:[],
    }
  },
  methods:{
    async getTzLoadMaterialRecordNg(){
      let {data: res} = await this.$axios.post('bus/tz/getTzLoadMaterialRecordNg',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tzLoadMaterialRecordNg = res.data;
      }
    }
  },
  created() {
    this.getTzLoadMaterialRecordNg()
  }
}
</script>

<style scoped>

</style>